exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
exports.i(require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!../styles/_utils.scss"), "");
// Module
exports.push([module.id, ".filter-label-filter-label-5F1CuotDmwr{}.filter-label-label-6Adhg432mwr{display:block;line-height:16px;padding-left:6px}.filter-label-trigger-65IEjJYXmwr{}.filter-label-filter-label-5F1CuotDmwr .filter-label-trigger-65IEjJYXmwr{width:130px;padding:2px 6px;justify-content:space-between;font-weight:normal;font-size:14px;color:var(--primary-text)}.filter-label-filter-label-5F1CuotDmwr .filter-label-trigger-65IEjJYXmwr>svg path{fill:var(--primary-text)}.filter-label-select-3eWBDSh5mwr{display:flex}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"filter-label": "filter-label-filter-label-5F1CuotDmwr " + require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!../styles/_utils.scss").locals["bar-label-container"] + "",
	"filterLabel": "filter-label-filter-label-5F1CuotDmwr " + require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!../styles/_utils.scss").locals["bar-label-container"] + "",
	"label": "filter-label-label-6Adhg432mwr " + require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!../styles/_utils.scss").locals["bar-label-label"] + "",
	"trigger": "filter-label-trigger-65IEjJYXmwr " + require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!../styles/_utils.scss").locals["bar-label-value"] + "",
	"select": "filter-label-select-3eWBDSh5mwr"
};